export const CATEGORIES = {
  proteccionCivil: 2,
  secretariaTrabajo: 3,
};
